export default {
  en: {
    buttonTitle: 'Download',
    errorNoData: "Report can't be generated, no data",
    hostVendorMix: 'Host vendor mix',
    networkVendorMix: 'Network vendor mix',
    hosts: 'HOSTS',
    paths: 'PATHS',
    scoreCardPerformance: 'PERFORMANCE',
    scoreCardRisk: 'RISK',
    scoreCardCapacity: 'CAPACITY',
    scoreCardSecurity: 'SECURITY',
  },
};
